import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2605000"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "Sistema de sprinklers instalado?"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "",
  title: "Observações"
}
const _hoisted_8 = { class: "ant-row ui-espaco-campos" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  class: "",
  title: "Detectores de fumaça instalados ?"
}
const _hoisted_11 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  class: "",
  title: "Observações"
}
const _hoisted_14 = { class: "ant-row ui-espaco-campos" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = {
  class: "",
  title: "Detectores de calor instalados?"
}
const _hoisted_17 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  class: "",
  title: "Observações"
}
const _hoisted_20 = { class: "ant-row ui-espaco-campos" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_22 = {
  class: "",
  title: "Sistema de alarme de incêndio funcional?"
}
const _hoisted_23 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "ui-campo-instrucao" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Central física, qual local esta instalada:", -1))
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  class: "",
  title: "Observações"
}
const _hoisted_33 = { class: "ant-row ui-espaco-campos" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_35 = {
  class: "",
  title: "Possui Extintores?"
}
const _hoisted_36 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Quantidade", -1))
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Tipo/modelos", -1))
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 2 }
const _hoisted_46 = {
  class: "",
  title: "Observações"
}
const _hoisted_47 = { class: "ant-row ui-espaco-campos" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_49 = {
  class: "",
  title: "Possui hidrantes instalado?"
}
const _hoisted_50 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "ant-row" }
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-espaco-campos-interno" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Quantidade", -1))
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20 ui-espaco-campos-interno" }, null, -1))
const _hoisted_57 = { key: 2 }
const _hoisted_58 = {
  class: "",
  title: "Observações"
}
const _hoisted_59 = { class: "ant-row ui-espaco-campos" }
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_61 = {
  class: "",
  title: "Qual o diâmetro nominal da tubulação principal da rede de hidrantes (linha de incêndio)?"
}
const _hoisted_62 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 2 }
const _hoisted_65 = {
  class: "",
  title: "Observações"
}
const _hoisted_66 = { class: "ant-row ui-espaco-campos" }
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_68 = {
  class: "",
  title: "Possui Reserva Técnica de Incêndio (RTI)?"
}
const _hoisted_69 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "ant-row" }
const _hoisted_72 = { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-espaco-campos-interno" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Volume de água (m³)", -1))
const _hoisted_74 = ["disabled"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20 ui-espaco-campos-interno" }, null, -1))
const _hoisted_76 = { key: 2 }
const _hoisted_77 = {
  class: "",
  title: "Observações"
}
const _hoisted_78 = { class: "ant-row ui-espaco-campos" }
const _hoisted_79 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_80 = {
  class: "",
  title: "Sistema de pressurização para hidrantes existente?"
}
const _hoisted_81 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { key: 2 }
const _hoisted_84 = {
  class: "",
  title: "Observações"
}
const _hoisted_85 = { class: "ant-row ui-espaco-campos" }
const _hoisted_86 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_87 = {
  class: "",
  title: "Distância até o Corpo de Bombeiros mais próximo",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_88 = {
  key: 1,
  style: {"width":"150px"},
  class: "ant-input-wrapper ant-input-group"
}
const _hoisted_89 = ["disabled"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "KM", -1))
const _hoisted_91 = {
  key: 2,
  style: {"margin-left":"10px"}
}
const _hoisted_92 = {
  key: 3,
  style: {"width":"150px"},
  class: "ant-input-wrapper ant-input-group"
}
const _hoisted_93 = ["disabled"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "MIN", -1))
const _hoisted_95 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_96 = { key: 1 }
const _hoisted_97 = {
  class: "",
  title: "Observações"
}
const _hoisted_98 = { class: "ant-row ui-espaco-campos" }
const _hoisted_99 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_100 = {
  class: "",
  title: "Possui bombeiro civil profissional no local?"
}
const _hoisted_101 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_102 = { key: 1 }
const _hoisted_103 = {
  class: "",
  title: "Observações"
}
const _hoisted_104 = { class: "ant-row ui-espaco-campos" }
const _hoisted_105 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_106 = {
  class: "",
  title: "Brigada de incêndio treinada e ativa?"
}
const _hoisted_107 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { class: "ui-campo-instrucao" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = {
  style: {"display":"flex","align-items":"center"},
  class: "ui-campo-instrucao"
}
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { key: 2 }
const _hoisted_114 = {
  class: "",
  title: "Observações"
}
const _hoisted_115 = { class: "ant-row ui-espaco-campos" }
const _hoisted_116 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_117 = {
  class: "",
  title: "A empresa possui mapa de risco/emergência afixados nas áreas comuns?"
}
const _hoisted_118 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_119 = { key: 1 }
const _hoisted_120 = {
  class: "",
  title: "Observações"
}
const _hoisted_121 = { class: "ant-row ui-espaco-campos" }
const _hoisted_122 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_123 = {
  class: "",
  title: "Existe plano formal de manutenção preventiva dos sistemas de incêndio?"
}
const _hoisted_124 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_125 = { key: 1 }
const _hoisted_126 = {
  class: "",
  title: "Observações"
}
const _hoisted_127 = { class: "ant-row ui-espaco-campos" }
const _hoisted_128 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_129 = {
  class: "",
  title: "Treinamentos periódicos de segurança são realizados?"
}
const _hoisted_130 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_131 = { key: 1 }
const _hoisted_132 = {
  class: "",
  title: "Observações"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 4 – SISTEMAS DE PROTEÇÃO CONTRA INCÊNDIO",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.sistemaSprinklersVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao4.sistemaSprinklersVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.sistemaSprinklersVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.sistemaSprinklersEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.sistemaSprinklersEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao4.sistemaSprinklersEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.sistemaSprinklersEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Sistema de sprinklers instalado? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('sistemaSprinklers')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.sistemaSprinklersVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.sistemaSprinklers,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computedSecao4.sistemaSprinklers = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.sistemaSprinklersVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.sistemaSprinklers,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.computedSecao4.sistemaSprinklers = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.sistemaSprinklers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.sistemaSprinklers), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.sistemaSprinklersVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", _hoisted_7, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.sistemaSprinklersObservacoesVisivel,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedSecao4.sistemaSprinklersObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.sistemaSprinklersObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.sistemaSprinklersObservacoes,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedSecao4.sistemaSprinklersObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.detectoresFumacaVisivel,
                        "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedSecao4.detectoresFumacaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Detectores de fumaça instalados ? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('detectoresFumaca')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.detectoresFumacaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 0,
                        checked: _ctx.computedSecao4.detectoresFumaca,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.computedSecao4.detectoresFumaca = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.detectoresFumacaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: !_ctx.computedSecao4.detectoresFumaca,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.computedSecao4.detectoresFumaca = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.detectoresFumaca)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.ManualPreenchimentoInspecao.detectoresFumaca), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.detectoresFumacaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.detectoresFumacaObservacoesVisivel,
                              "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedSecao4.detectoresFumacaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.detectoresFumacaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.detectoresFumacaObservacoes,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedSecao4.detectoresFumacaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.detectoresCalorVisivel,
                        "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedSecao4.detectoresCalorVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.detectoresCalorVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.detectoresCalorEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.detectoresCalorEnviarEmail,
                            "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedSecao4.detectoresCalorEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.detectoresCalorEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Detectores de calor instalados? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('detectoresCalor')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.detectoresCalorVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.detectoresCalor,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.computedSecao4.detectoresCalor = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.detectoresCalorVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.detectoresCalor,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.computedSecao4.detectoresCalor = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.detectoresCalor)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.ManualPreenchimentoInspecao.detectoresCalor), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.detectoresCalorVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.detectoresCalorObservacoesVisivel,
                              "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSecao4.detectoresCalorObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.detectoresCalorObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.detectoresCalorObservacoes,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedSecao4.detectoresCalorObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.sistemaAlarmeFuncionalVisivel,
                        "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.computedSecao4.sistemaAlarmeFuncionalVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.sistemaAlarmeFuncionalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.sistemaAlarmeFuncionalEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.sistemaAlarmeFuncionalEnviarEmail,
                            "onUpdate:checked": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedSecao4.sistemaAlarmeFuncionalEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.sistemaAlarmeFuncionalEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Sistema de alarme de incêndio funcional? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('sistemaAlarmeFuncional')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.sistemaAlarmeFuncionalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.sistemaAlarmeFuncional,
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.computedSecao4.sistemaAlarmeFuncional = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.sistemaAlarmeFuncionalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.sistemaAlarmeFuncional,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.computedSecao4.sistemaAlarmeFuncional = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.sistemaAlarmeFuncional)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.ManualPreenchimentoInspecao.sistemaAlarmeFuncional), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao4.sistemaAlarmeFuncionalVisivel && _ctx.computedSecao4.sistemaAlarmeFuncional))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, [
                        _createTextVNode("- A central de alarme é monitorada remotamente "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.centralAlarmeMonitoradaRemotamente,
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.computedSecao4.centralAlarmeMonitoradaRemotamente = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao4.centralAlarmeMonitoradaRemotamente,
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.computedSecao4.centralAlarmeMonitoradaRemotamente = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.computedSecao4.centralAlarmeLocalInstalada) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_30), [
                            [_vModelText, _ctx.computedSecao4.centralAlarmeLocalInstalada]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.sistemaAlarmeFuncionalVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.sistemaAlarmeFuncionalObservacoesVisivel,
                              "onUpdate:checked": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedSecao4.sistemaAlarmeFuncionalObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.sistemaAlarmeFuncionalObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.sistemaAlarmeFuncionalObservacoes,
                            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.computedSecao4.sistemaAlarmeFuncionalObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.possuiExtintoresVisivel,
                        "onUpdate:checked": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedSecao4.possuiExtintoresVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.possuiExtintoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.possuiExtintoresEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.possuiExtintoresEnviarEmail,
                            "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.computedSecao4.possuiExtintoresEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.possuiExtintoresEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Possui Extintores? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiExtintores')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiExtintoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.possuiExtintores,
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.computedSecao4.possuiExtintores = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiExtintoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.possuiExtintores,
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.computedSecao4.possuiExtintores = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiExtintores)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiExtintores), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao4.possuiExtintoresVisivel && _ctx.computedSecao4.possuiExtintores))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao4.extintoresQuantidade) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_41), [
                            [_vModelText, _ctx.computedSecao4.extintoresQuantidade]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedSecao4.extintoresTiposModelos) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_44), [
                            [_vModelText, _ctx.computedSecao4.extintoresTiposModelos]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.possuiExtintoresVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.possuiExtintoresObservacoesVisivel,
                              "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedSecao4.possuiExtintoresObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.possuiExtintoresObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.possuiExtintoresObservacoes,
                            "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.computedSecao4.possuiExtintoresObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.possuiHidrantesVisivel,
                        "onUpdate:checked": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.computedSecao4.possuiHidrantesVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.possuiHidrantesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.possuiHidrantesEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.possuiHidrantesEnviarEmail,
                            "onUpdate:checked": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.computedSecao4.possuiHidrantesEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.possuiHidrantesEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Possui hidrantes instalado? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiHidrantes')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiHidrantesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.possuiHidrantes,
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.computedSecao4.possuiHidrantes = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiHidrantesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.possuiHidrantes,
                        onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.computedSecao4.possuiHidrantes = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiHidrantes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiHidrantes), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao4.possuiHidrantesVisivel && _ctx.computedSecao4.possuiHidrantes))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.computedSecao4.hidrantesQuantidade) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_55), [
                            [_vModelText, _ctx.computedSecao4.hidrantesQuantidade]
                          ])
                        ]),
                        _hoisted_56
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.possuiHidrantesVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createElementVNode("label", _hoisted_58, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.possuiHidrantesObservacoesVisivel,
                              "onUpdate:checked": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.computedSecao4.possuiHidrantesObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.possuiHidrantesObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.possuiHidrantesObservacoes,
                            "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.computedSecao4.possuiHidrantesObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("label", _hoisted_61, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantesVisivel,
                        "onUpdate:checked": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantesVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.diametroNominalTubulacaoHidrantesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.diametroNominalTubulacaoHidrantesEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantesEnviarEmail,
                            "onUpdate:checked": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantesEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.diametroNominalTubulacaoHidrantesEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual o diâmetro nominal da tubulação principal da rede de hidrantes (linha de incêndio)? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('diametroNominalTubulacaoHidrantes')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.diametroNominalTubulacaoHidrantes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.ManualPreenchimentoInspecao.diametroNominalTubulacaoHidrantes), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.diametroNominalTubulacaoHidrantesVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantes63Mm,
                          "onUpdate:checked": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantes63Mm) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("2½” (63 mm)")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantes75Mm,
                          "onUpdate:checked": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantes75Mm) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("3” (75 mm)")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantes100Mm,
                          "onUpdate:checked": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantes100Mm) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("4” (100 mm)")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantes150Mm,
                          "onUpdate:checked": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantes150Mm) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("6” (150 mm)")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.diametroNominalTubulacaoHidrantesVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("label", _hoisted_65, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.diametroNominalTubulacaoHidrantesObservacoesVisivel,
                              "onUpdate:checked": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantesObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.diametroNominalTubulacaoHidrantesObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.diametroNominalTubulacaoHidrantesObservacoes,
                            "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.computedSecao4.diametroNominalTubulacaoHidrantesObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("label", _hoisted_68, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.possuiRtiVisivel,
                        "onUpdate:checked": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.computedSecao4.possuiRtiVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.possuiRtiVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.possuiRtiEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.possuiRtiEnviarEmail,
                            "onUpdate:checked": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.computedSecao4.possuiRtiEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.possuiRtiEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Possui Reserva Técnica de Incêndio (RTI)? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[58] || (_cache[58] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiRti')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiRtiVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.possuiRti,
                        onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.computedSecao4.possuiRti = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiRtiVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.possuiRti,
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.computedSecao4.possuiRti = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiRti)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiRti), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao4.possuiRtiVisivel && _ctx.computedSecao4.possuiRti))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.computedSecao4.rtiVolumeM3) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_74), [
                            [_vModelText, _ctx.computedSecao4.rtiVolumeM3]
                          ])
                        ]),
                        _hoisted_75
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.possuiRtiVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("label", _hoisted_77, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.possuiRtiObservacoesVisivel,
                              "onUpdate:checked": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.computedSecao4.possuiRtiObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.possuiRtiObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.possuiRtiObservacoes,
                            "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.computedSecao4.possuiRtiObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.sistemaPressurizacaoHidrantesVisivel,
                        "onUpdate:checked": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.sistemaPressurizacaoHidrantesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.sistemaPressurizacaoHidrantesEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.sistemaPressurizacaoHidrantesEnviarEmail,
                            "onUpdate:checked": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.sistemaPressurizacaoHidrantesEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Sistema de pressurização para hidrantes existente? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[66] || (_cache[66] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('sistemaPressurizacaoHidrantes')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.sistemaPressurizacaoHidrantes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.ManualPreenchimentoInspecao.sistemaPressurizacaoHidrantes), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesVisivel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.sistemaPressurizacaoHidrantesGravidade,
                          "onUpdate:checked": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesGravidade) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Gravidade")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.sistemaPressurizacaoHidrantesBombas,
                          "onUpdate:checked": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesBombas) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Bombas")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.sistemaPressurizacaoHidrantesVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _createElementVNode("label", _hoisted_84, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.sistemaPressurizacaoHidrantesObservacoesVisivel,
                              "onUpdate:checked": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.sistemaPressurizacaoHidrantesObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.sistemaPressurizacaoHidrantesObservacoes,
                            "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.computedSecao4.sistemaPressurizacaoHidrantesObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("label", _hoisted_87, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel,
                        "onUpdate:checked": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.distanciaCorpoBombeirosKmEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.distanciaCorpoBombeirosKmEnviarEmail,
                            "onUpdate:checked": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.computedSecao4.distanciaCorpoBombeirosKmEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao4.distanciaCorpoBombeirosKmEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Distância até o Corpo de Bombeiros mais próximo: "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[73] || (_cache[73] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('distanciaCorpoBombeirosKm')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.computedSecao4.distanciaCorpoBombeirosKm) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_89), [
                          [_vModelText, _ctx.computedSecao4.distanciaCorpoBombeirosKm]
                        ]),
                        _hoisted_90
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Tempo Estimado:"))
                    : _createCommentVNode("", true),
                  (_ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.computedSecao4.distanciaCorpoBombeirosTempoEstimadoMin) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_93), [
                          [_vModelText, _ctx.computedSecao4.distanciaCorpoBombeirosTempoEstimadoMin]
                        ]),
                        _hoisted_94
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.distanciaCorpoBombeirosKm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.ManualPreenchimentoInspecao.distanciaCorpoBombeirosKm), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.distanciaCorpoBombeirosKmVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                      _createElementVNode("label", _hoisted_97, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.distanciaCorpoBombeirosObservacoesVisivel,
                              "onUpdate:checked": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.computedSecao4.distanciaCorpoBombeirosObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.distanciaCorpoBombeirosObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.distanciaCorpoBombeirosObservacoes,
                            "onUpdate:value": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.computedSecao4.distanciaCorpoBombeirosObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("label", _hoisted_100, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.bombeiroCivilProfissionalVisivel,
                        "onUpdate:checked": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.computedSecao4.bombeiroCivilProfissionalVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.bombeiroCivilProfissionalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.bombeiroCivilProfissionalEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.bombeiroCivilProfissionalEnviarEmail,
                            "onUpdate:checked": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.computedSecao4.bombeiroCivilProfissionalEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.bombeiroCivilProfissionalEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Possui bombeiro civil profissional no local? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[80] || (_cache[80] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('bombeiroCivilProfissional')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.bombeiroCivilProfissionalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.bombeiroCivilProfissional,
                        onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.computedSecao4.bombeiroCivilProfissional = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.bombeiroCivilProfissionalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.bombeiroCivilProfissional,
                        onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.computedSecao4.bombeiroCivilProfissional = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.bombeiroCivilProfissional)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.ManualPreenchimentoInspecao.bombeiroCivilProfissional), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.bombeiroCivilProfissionalVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                      _createElementVNode("label", _hoisted_103, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.bombeiroCivilProfissionalObservacoesVisivel,
                              "onUpdate:checked": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.computedSecao4.bombeiroCivilProfissionalObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.bombeiroCivilProfissionalObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.bombeiroCivilProfissionalObservacoes,
                            "onUpdate:value": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.computedSecao4.bombeiroCivilProfissionalObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("label", _hoisted_106, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel,
                        "onUpdate:checked": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.brigadaIncendioTreinadaAtivaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.brigadaIncendioTreinadaAtivaEnviarEmail,
                            "onUpdate:checked": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.computedSecao4.brigadaIncendioTreinadaAtivaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.brigadaIncendioTreinadaAtivaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Brigada de incêndio treinada e ativa? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[87] || (_cache[87] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('brigadaIncendioTreinadaAtiva')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.brigadaIncendioTreinadaAtiva,
                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.computedSecao4.brigadaIncendioTreinadaAtiva = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.brigadaIncendioTreinadaAtiva,
                        onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.computedSecao4.brigadaIncendioTreinadaAtiva = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.brigadaIncendioTreinadaAtiva)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.ManualPreenchimentoInspecao.brigadaIncendioTreinadaAtiva), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel && _ctx.computedSecao4.brigadaIncendioTreinadaAtiva))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                      _createElementVNode("span", _hoisted_109, [
                        _createTextVNode("Atendimento 24h? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao4.brigadaAtendimento24h,
                          onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.computedSecao4.brigadaAtendimento24h = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao4.brigadaAtendimento24h,
                          onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.computedSecao4.brigadaAtendimento24h = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _hoisted_110,
                      _createElementVNode("span", _hoisted_111, [
                        _createTextVNode("Quantidade de brigadistas: "),
                        _withDirectives(_createElementVNode("input", {
                          style: {"width":"300px"},
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.computedSecao4.brigadaQtdBrigadistas) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_112), [
                          [_vModelText, _ctx.computedSecao4.brigadaQtdBrigadistas]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.brigadaIncendioTreinadaAtivaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                      _createElementVNode("label", _hoisted_114, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.brigadaIncendioTreinadaAtivaObservacoesVisivel,
                              "onUpdate:checked": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.computedSecao4.brigadaIncendioTreinadaAtivaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.brigadaIncendioTreinadaAtivaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.brigadaIncendioTreinadaAtivaObservacoes,
                            "onUpdate:value": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.computedSecao4.brigadaIncendioTreinadaAtivaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("label", _hoisted_117, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.possuiMapaRiscoEmergenciaVisivel,
                        "onUpdate:checked": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.computedSecao4.possuiMapaRiscoEmergenciaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.possuiMapaRiscoEmergenciaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.possuiMapaRiscoEmergenciaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.possuiMapaRiscoEmergenciaEnviarEmail,
                            "onUpdate:checked": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.computedSecao4.possuiMapaRiscoEmergenciaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.possuiMapaRiscoEmergenciaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" A empresa possui mapa de risco/emergência afixados nas áreas comuns? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[97] || (_cache[97] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiMapaRiscoEmergencia')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiMapaRiscoEmergenciaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.possuiMapaRiscoEmergencia,
                        onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.computedSecao4.possuiMapaRiscoEmergencia = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiMapaRiscoEmergenciaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.possuiMapaRiscoEmergencia,
                        onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.computedSecao4.possuiMapaRiscoEmergencia = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiMapaRiscoEmergencia)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiMapaRiscoEmergencia), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.possuiMapaRiscoEmergenciaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                      _createElementVNode("label", _hoisted_120, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.possuiMapaRiscoEmergenciaObservacoesVisivel,
                              "onUpdate:checked": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.computedSecao4.possuiMapaRiscoEmergenciaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.possuiMapaRiscoEmergenciaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.possuiMapaRiscoEmergenciaObservacoes,
                            "onUpdate:value": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.computedSecao4.possuiMapaRiscoEmergenciaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("label", _hoisted_123, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioVisivel,
                        "onUpdate:checked": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioEnviarEmail,
                            "onUpdate:checked": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe plano formal de manutenção preventiva dos sistemas de incêndio? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[104] || (_cache[104] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiPlanoManutencaoSistemasIncendio')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendio,
                        onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendio = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendio,
                        onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendio = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiPlanoManutencaoSistemasIncendio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiPlanoManutencaoSistemasIncendio), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                      _createElementVNode("label", _hoisted_126, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioObservacoesVisivel,
                              "onUpdate:checked": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioObservacoes,
                            "onUpdate:value": _cache[108] || (_cache[108] = ($event: any) => ((_ctx.computedSecao4.possuiPlanoManutencaoSistemasIncendioObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("label", _hoisted_129, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao4.treinamentosPeriodicosSegurancaVisivel,
                        "onUpdate:checked": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.computedSecao4.treinamentosPeriodicosSegurancaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao4.treinamentosPeriodicosSegurancaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao4.treinamentosPeriodicosSegurancaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao4.treinamentosPeriodicosSegurancaEnviarEmail,
                            "onUpdate:checked": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.computedSecao4.treinamentosPeriodicosSegurancaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao4.treinamentosPeriodicosSegurancaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Treinamentos periódicos de segurança são realizados? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[111] || (_cache[111] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('treinamentosPeriodicosSeguranca')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao4.treinamentosPeriodicosSegurancaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao4.treinamentosPeriodicosSeguranca,
                        onClick: _cache[112] || (_cache[112] = ($event: any) => (_ctx.computedSecao4.treinamentosPeriodicosSeguranca = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao4.treinamentosPeriodicosSegurancaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao4.treinamentosPeriodicosSeguranca,
                        onClick: _cache[113] || (_cache[113] = ($event: any) => (_ctx.computedSecao4.treinamentosPeriodicosSeguranca = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.treinamentosPeriodicosSeguranca)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_ctx.ManualPreenchimentoInspecao.treinamentosPeriodicosSeguranca), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao4.treinamentosPeriodicosSegurancaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                      _createElementVNode("label", _hoisted_132, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao4.treinamentosPeriodicosSegurancaObservacoesVisivel,
                              "onUpdate:checked": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.computedSecao4.treinamentosPeriodicosSegurancaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao4.treinamentosPeriodicosSegurancaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao4.treinamentosPeriodicosSegurancaObservacoes,
                            "onUpdate:value": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.computedSecao4.treinamentosPeriodicosSegurancaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}